/**
 * Single source of truth for progress-bar track thickness, shared by every
 * row-level data bar in the app (ShareBarCell, ProgressBar.components,
 * ProgressBar). Kept out of both bar implementations so neither one can
 * silently drift from the other.
 */
export const PROGRESS_BAR_HEIGHT = 7;
